import { render, staticRenderFns } from "./CorrectStatus.vue?vue&type=template&id=99d995a2"
import script from "./CorrectStatus.vue?vue&type=script&lang=js"
export * from "./CorrectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports